import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { PropType } from "vue";

import { formatFractionalPrice } from "@/utils";
import { useCurrencies } from "@/composables";
import { Decimal } from "@/libs/decimal";

import FractionFormatter from "@/components/Common/Pricing/FractionFormatter.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'FiatPriceFormatter',
  props: {
  fiatPrice: {
    type: Object as PropType<Decimal>,
    required: true,
  },
},
  setup(__props) {



const { currentCurrencyInfo } = useCurrencies();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _mergeProps(_ctx.$attrs, { class: "fiat-price-formatter d-inline-flex" }), [
    _createElementVNode("div", null, _toDisplayString(_unref(currentCurrencyInfo).symbol), 1),
    _createVNode(FractionFormatter, {
      "fractional-price": _unref(formatFractionalPrice)(__props.fiatPrice)
    }, null, 8, ["fractional-price"])
  ], 16))
}
}

})